import * as Tabs from '@radix-ui/react-tabs';
import { v4 as uuid4 } from 'uuid';
import { useTabControl } from '../../../hooks/useTabControl';
import { TabContent, TabOptionsList, TabProps } from './tab';

const styles = {
  'tab-list': 'w-full flex gap-2 sticky z-10',
};

export default function HTab(props: TabProps) {
  const { set, current, tabOptions, tabContent, tabControlClassName } = props;
  const [showClose, showCloseBtn, hideCloseBtn] = useTabControl(current, set);

  /* 
    Note: The option values are used to select the tab
    options
  */
  const actualTabOptions = Object.values(tabOptions).map((option) =>
    option.toLowerCase()
  );

  return (
    <Tabs.Root
      value={current}
      orientation="vertical"
      onValueChange={(value: string) => {
        showCloseBtn();
        set(value);
      }}
    >
      <Tabs.List
        aria-label="tabs"
        className={`${styles['tab-list']} ${tabControlClassName}`}
      >
        <TabOptionsList
          showClose={props.withoutCloseEffect ? false : showClose}
          currentValue={current}
          tabOptions={tabOptions}
          closeFunction={hideCloseBtn}
        />
      </Tabs.List>
      {actualTabOptions.map((option: string) => (
        <TabContent key={uuid4()} value={option}>
          {tabContent[option] && tabContent[option]()}
        </TabContent>
      ))}
    </Tabs.Root>
  );
}
